module.exports = __webpack_public_path__ + "img/lazy-bastard.6bfd1bcd.png";